module.exports = __webpack_public_path__ + "/16cbb6488b0eef3d4743f070446bacba.svg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/landing-pages/components/integrations/assets/googledocs.svg
 ** module id = 1605
 ** module chunks = 0
 **/